import React, { memo } from 'react'
import styles from './styles.module.scss'
import logoIcon from './icons/icon.svg'
import logoBigIcon from './icons/icon_big.svg'
import cn from 'classnames'

import ImageComponent from '../../../../../UI/Image/ImageComponent'
import { useSelector } from 'react-redux'

const Banner = memo(() => {
  const referralData = useSelector(({ billing }) => billing.referralData)

  return (
    // <div>
    <div className={cn(styles.banner, [!referralData && styles.fullWidth])}>
      <div className={styles.logo}>
        <ImageComponent src={referralData ? logoIcon : logoIcon} />
      </div>
      <h1 className={styles.title}>boost your career prospects</h1>
      <div className={styles.description}>
        <p>
          We offer tools that will help you stand out among competitors and accelerate your path to a successful
          maritime career.
        </p>

        <p>Invest in yourself — become an even more sought-after specialist today!</p>
      </div>
    </div>
    // </div>
  )
})

export default Banner
